// Utility function to get authentication headers with token
export const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  
  const headers = {
    'Content-Type': 'application/json',
  };
  
  if (token) {
    headers['Authorization'] = token; // No 'Bearer '
  }
  
  return headers;
};

// Utility function to make authenticated API calls
export const authenticatedFetch = async (url, options = {}) => {
  const headers = getAuthHeaders();
  
  const config = {
    ...options,
    headers: {
      ...headers,
      ...options.headers,
    },
  };

  if (typeof FormData !== 'undefined' && options.body instanceof FormData) {
    delete config.headers['Content-Type'];
  }

  const response = await fetch(url, config);
  
  if (!response.ok) {
    return response.json();
    throw new Error(`Error: ${response.status} - ${response.statusText}`);
  }
  
  return response.json();
}; 
